
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiIcon from '@/components/UiIcon.vue'
import AppFooter from '@/components/AppFooter.vue'
import moment from 'moment'
import { formatSunsetMessage, sunsetMessageParagraphs } from '@/services/orgSunset'

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export default Vue.extend({
  name: 'OrgSunset',
  components: { UiCard, AppFooter, UiIcon },
  computed: {
    organization() { return this.$store.getters.organization },
    sunset() { return this.organization.sunset },
    localeIsDe() { return this.$i18n.locale === 'de' },
    brandColor() {
      return this.organization.brand.color || '#ff567e'
    },
    brandVars() {
      const brand = this.brandColor
      return {
        '--sunset-brand': brand,
        background: `radial-gradient(ellipse 110% 70% at 50% -15%, ${brand}22, transparent 52%), linear-gradient(180deg, #ecefef 0%, #f5f5f5 100%)`,
      }
    },
    formattedEffectiveAt() {
      if (!this.sunset?.effectiveAt) return '—'
      return moment(this.sunset.effectiveAt).format('DD.MM.YYYY')
    },
    messageVars() {
      return {
        date: this.formattedEffectiveAt,
        orgName: this.organization.brand.name,
      }
    },
    title() {
      const custom = this.localeIsDe ? this.sunset?.titleDe : this.sunset?.titleEn
      if (custom && custom.trim()) {
        return formatSunsetMessage(custom, this.messageVars)
      }
      return this.$t('defaultTitle')
    },
    messageParagraphs() {
      const custom = this.localeIsDe ? this.sunset?.messageDe : this.sunset?.messageEn
      const template = (custom && custom.trim())
        ? custom
        : this.$t('defaultMessage')
      return sunsetMessageParagraphs(template, this.messageVars)
    },
    hasContact() {
      return !!(this.sunset?.contactName || this.sunset?.contactEmail || this.sunset?.contactPhone)
    },
  },
  methods: {
    highlightDateInParagraph(paragraph: string): string {
      const safe = escapeHtml(paragraph)
      const date = this.formattedEffectiveAt
      if (!date || date === '—') return safe
      const escapedDate = escapeHtml(date)
      return safe.replace(
        escapedDate,
        `<strong class="org-sunset__date">${escapedDate}</strong>`
      )
    },
  },
})
